//    $('.single-option-radio label').on('click', function(){
//       var price = $(this).attr('data-variantprice');
//       $('.product-single__meta #ProductPrice').text(price);
//     });
    $('body').on('keyup','.custom-message input', function(){
      var entered_char = this.value.length;
      $('.custom-message .character-count').text(entered_char);
    });
    $('.type-file-wrapper #fill-type').on('change', function(){
      var val = $(this).val();
      if(val == 'balloon'){
        $('.mini-color').show();
        $('.feather-color').hide();
      }else if(val == 'feather'){
        $('.mini-color').hide();
        $('.feather-color').show();
      }else{
        $('.mini-color').hide();
        $('.feather-color').hide();
      }
    });
    $('#custom-message-color').on('change', function(){
      var val = $(this).val();
      if(val != ''){
        $(this).find('option').each(function(){
          var optionVal = $(this).val();
          if(val == optionVal){
           $(this).attr('selected','true');
          }
        });
      }
    });
    $('.shop-page-detail .shop-title').click(function(){
      $('.shop-page-detail .shop-title').removeClass('active');
      $(this).addClass('active');
    });
    
    
    $('.slider-ballon').slick({
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: true,
        fadeSpeed: 1000
    });
 
    
  
          
    $('[data-latex-product]').on('click', function(){
      $('[data-latext-pro-detail]').removeClass('d-none');
       $('.shape').addClass('d-none');
       $('.shape-products').addClass('d-none');
       $(this).addClass('active-pro');
       $('[data-foil-product]').removeClass('active-pro');
    });
    $('[data-latext-pro-detail] #ProductSelect-option-1 input').on('change', function(){
      var val = $(this).val();
      if(val == 'No'){
        $('[data-latext-pro-detail] .custom-message').hide();
      }else{
       $('[data-latext-pro-detail] .custom-message').show(); 
      }
    });

    $('.heart-product #ProductSelect-option-0 input').on('change', function(){
	  var val = $(this).val();
      if(val == 'No'){
        $('.heart-product .custom-message').hide();
      }else{
       $('.heart-product .custom-message').show(); 
      }
    });
    $('.rounded-product #ProductSelect-option-0 input').on('change', function(){
	  var val = $(this).val();
      if(val == 'No'){
        $('.rounded-product .custom-message').hide();
      }else{
       $('.rounded-product .custom-message').show(); 
      }
    });
    $('[data-latext-addbtn]').on('click', function(e){
      e.preventDefault();
      var $form = $(this).closest('form');
      var option1 = $form.find('#ProductSelect-option-0').find('input:checked').val();
      var option2 = $form.find('#ProductSelect-option-1').find('input:checked').val();
      var variant_name = option1 +' / '+ option2;
      var variant_id = '';
      var qty = $form.find('.product-single__quantity input').val();
      var custom_text = $form.find('.custom-message input').val();
      var mini_color = $form.find('.mini-color input:checked').val();
      $($form).find('#ProductSelect option').each(function(){
        var variant = $(this).attr("data-variant-title");
        if(variant == variant_name ){
          variant_id = $(this).val();
        }
      });
      $.ajax({
      	type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: qty,
          id: variant_id,
          "properties": {
            "Custom Text":custom_text,
            "Balloon Color": mini_color
      	  }
        },
        dataType: 'json', 
       	success: function (data) { 
         window.location.href="/cart";

       	} 
 	  });
      
    });
    $('[data-number-addbtn]').on('click', function(e){
      e.preventDefault();
      var $form = $(this).closest('form');
      var option1 = $form.find('#ProductSelect-option-0').find('input:checked').val();
      //var option2 = $form.find('#ProductSelect-option-1').find('input:checked').val();
      var variant_name = option1;
      var variant_id = '';
      var qty = $form.find('.product-single__quantity input').val();
      //var custom_text = $form.find('.custom-message input').val();
      var mini_color = $form.find('.mini-color input:checked').val();
      $($form).find('#ProductSelect option').each(function(){
        var variant = $(this).attr("data-variant-title");
        if(variant == variant_name ){
          variant_id = $(this).val();
        }
      });
      $.ajax({
      	type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: qty,
          id: variant_id,
          "properties": {
            "Balloon Color": mini_color
      	  }
        },
        dataType: 'json', 
       	success: function (data) { 
         window.location.href="/cart";

       	} 
 	  });
    });
    $('[data-heart-addbtn]').on('click', function(e){
      e.preventDefault();
      var $form = $(this).closest('form');
      var option1 = $form.find('#ProductSelect-option-0').find('input:checked').val();
      //var option2 = $form.find('#ProductSelect-option-1').find('input:checked').val();
      var variant_name = option1;
      var variant_id = '';
      var qty = $form.find('.product-single__quantity input').val();
      var custom_text = $form.find('.custom-message input').val();
      var mini_color = $form.find('.custom-swatch .swatch-element input:checked').val();
      $($form).find('#ProductSelect option').each(function(){
        var variant = $(this).attr("data-variant-title");
        if(variant == variant_name ){
          variant_id = $(this).val();
        }
      });
      $.ajax({
      	type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: qty,
          id: variant_id,
          "properties": {
             "Custom Text":custom_text,
            "Balloon Color": mini_color
      	  }
        },
        dataType: 'json', 
       	success: function (data) { 
         window.location.href="/cart";

       	} 
 	  });
    });
    $('[data-round-addbtn]').on('click', function(e){
      e.preventDefault();
      var $form = $(this).closest('form');
      var option1 = $form.find('#ProductSelect-option-0').find('input:checked').val();
      //var option2 = $form.find('#ProductSelect-option-1').find('input:checked').val();
      var variant_name = option1;
      var variant_id = '';
      var qty = $form.find('.product-single__quantity input').val();
      var custom_text = $form.find('.custom-message input').val();
      var mini_color = $form.find('.custom-swatch .swatch-element input:checked').val();
      $($form).find('#ProductSelect option').each(function(){
        var variant = $(this).attr("data-variant-title");
        if(variant == variant_name ){
          variant_id = $(this).val();
        }
      });
      $.ajax({
      	type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: qty,
          id: variant_id,
          "properties": {
             "Custom Text":custom_text,
            "Balloon Color": mini_color
      	  }
        },
        dataType: 'json', 
       	success: function (data) { 
         window.location.href="/cart";

       	} 
 	  });
    });
    $('[data-foil-product]').on('click', function(){
      $(this).addClass('active-pro');
       $('.shape-products').removeClass('d-none');
      $('[data-latex-product]').removeClass('active-pro');
      $('.shape').removeClass('d-none');
      $('[data-latext-pro-detail]').addClass('d-none');
    });
    $('.number-image').on('click', function(){
      $('.number-product').removeClass('d-none');
      $('.star-product').addClass('d-none');
      $('.heart-product').addClass('d-none');
      $('.rounded-product').addClass('d-none');

    });
	$('.star-image').on('click', function(){
      $('.number-product').addClass('d-none');
      $('.star-product').removeClass('d-none');
      $('.heart-product').addClass('d-none');
      $('.rounded-product').addClass('d-none');

    });
	$('.heart-image').on('click', function(){
      $('.number-product').addClass('d-none');
      $('.star-product').addClass('d-none');
      $('.heart-product').removeClass('d-none');
      $('.rounded-product').addClass('d-none');

    });
	$('.rounded-image').on('click', function(){
      $('.number-product').addClass('d-none');
      $('.star-product').addClass('d-none');
      $('.heart-product').addClass('d-none');
      $('.rounded-product').removeClass('d-none');

    });
 
$('.add-greetbtn-wrapper .add-greetings').on('click', function(event){
  event.preventDefault();
  $(this).hide();
  $('.greeting-wrapper').addClass('show');
});
$('.greetbtn-wrapper .close-greetings').on('click', function(event){
  event.preventDefault();
  $('.add-greetbtn-wrapper .add-greetings').show();
  $('.greeting-wrapper').removeClass('show');
});



  

function ChangeUrl(page, url) {

   if (typeof (history.pushState) != "undefined") {
     var obj = { Page: page, Url: url };
     history.pushState(obj, obj.Page, obj.Url);
   }
 }

     
var collectionNewUrl = $('.filter').data('collection-url');
var collFilters = $('.coll-filter');

$('.coll-filter').on('change', function () {
  var Sortby_val = window.location.search;
  var newTags = [];
  var collection;
  var newarr = [];
  var newUrl;
  if($(this).val() == 'all'){
	window.location.href = collectionNewUrl;
    return;
  }
  collFilters.each(function() {

    if ($(this).find("option:selected")) {
      if($(this).find('option:selected').val() != 'all'){
        newTags.push($(this).find('option:selected').val());
      } 
    }

  });

  if (newTags.length) {

    $.each(newTags , function(index, val) { 
        newarr.push(val);
    });

    var tagsUrl = newarr.join('+');
    var newUrl = collectionNewUrl;
    if (tagsUrl) {
             newUrl += '/' + tagsUrl;
	}
    ChangeUrl(collection,newUrl); 
    console.log('hiii',newUrl);
    $.ajax({
       type:'GET',
       url:newUrl,
       beforeSend: function(){ 
         $(".coll-grid").hide();
       },
       success:function(response){
         $("#loader").hide();
         $(".coll-grid").show();
          var result = $(response).find(".main-content").find('.coll-grid').html();
          console.log('hellooo',result);
          $(".coll-grid").html(result);
       }
    }); 
  }
   

});    
          
$('.collection-sidebar .close_icon').on('click', function(){                                   
     $(this).removeClass('active-step').addClass('hide-step');
     $(this).next('.expand_icon').addClass('active-step').removeClass('hide-step');
  	 $('.active-drop').addClass('drop-hide');
});
$('.collection-sidebar .expand_icon').on('click', function(){                                   
     $(this).removeClass('active-step').addClass('hide-step');
     $(this).prev('.close_icon').addClass('active-step').removeClass('hide-step');
  	 $('.active-drop').removeClass('drop-hide');
});

// $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();
//     var objectSelect = $(".scroll-");
//     var objectPosition = objectSelect.offset().top;
//     if (scroll > objectPosition) {
//         $(".header").addClass("change");
//     } else {
//         $(".header").removeClass("change");
//     }
// });

$('.mobile-slider-only').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button class="slide-arrow prev-arrow"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"></button>'
});
$('.addons-slider').slick({
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows: true,
  prevArrow: '<a class="slide-arrow prev-arrow"></a>',
  nextArrow: '<a class="slide-arrow next-arrow"></a>'
});

$('.addons-slider input').on('change', function(event){
  event.preventDefault();
  var $this = $(this)
  var variant_id = $this.val();
  
   if($this.prop("checked") == true){
     addAddons(variant_id);
      
   } else if($this.prop("checked") == false){
     removeAddons(variant_id);
   }
});
function addAddons(variant_id){
  var addData = {
    'id':variant_id, 
    'quantity':1
  };

  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(json) {
    /* we have JSON */
    console.log(json)
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
}
function removeAddons(variant_id){
  var removeData = {
    'id':variant_id, 
    'quantity':0
  };
  
  fetch('/cart/change.js', {
    body: JSON.stringify(removeData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(json) {
    /* we have JSON */
    console.log(json)
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
  
}
var headerHeight = $('.site-header').height();
var ribbon_height = $('.announcement-bar').height();
var headerTotalheight = headerHeight + ribbon_height;
$('.template-index #PageContainer').css('padding-top', headerTotalheight);


    

	$('.slider-thumb-pro').not('.slick-initialized').slick({
		autoplay: true,
		vertical: true,
		infinite: true,
		verticalSwiping: true,
		slidesPerRow: 5,
		slidesToShow: 5,
		asNavFor: '.slider-preview-pro',
		focusOnSelect: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-up"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-down"></i></button>',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					vertical: false,
				}
			},
			{
				breakpoint: 479,
				settings: {
					vertical: false,
					slidesPerRow: 3,
					slidesToShow: 3,
				}
			},
		]
	});
	$('.slider-preview-pro').not('.slick-initialized').slick({
		autoplay: true,
		vertical: true,
		infinite: true,
		slidesPerRow: 1,
		slidesToShow: 1,
		asNavFor: '.slider-thumb-pro',
		arrows: false,
		draggable: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					vertical: false,
					fade: true,
				}
			},
		]
	});











	
